import { type ReactNode } from 'react';
import classNames from 'classnames';
import styles from './ModalContent.module.scss';

interface ModalContentProps {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  Icon: any;
  loading?: boolean;
  title: string;
}

const ModalContent = ({
  children,
  className,
  contentClassName,
  Icon,
  loading = false,
  title,
}: ModalContentProps) => {
  return (
    <div className={classNames(styles.detailView, className)}>
      <h2 className={styles.detailTitle}>
        <Icon
          className={classNames(styles.icon, {
            [styles.progressIcon]: loading,
          })}
        />
        <span className={styles.text}>{title}</span>
      </h2>
      <div className={classNames(contentClassName)}>{children}</div>
    </div>
  );
};

export default ModalContent;
